module.exports = __webpack_public_path__ + "media/images/wines/airen-24-barricas/bottle-24d64a6c3e1c4ae0a6f3d706277eaadf.png";